document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('.service-card__header');

  headers.forEach(function (header) {
    header.addEventListener('click', function () {
      const card = header.closest('.service-card');

      // simply toggle this card, don't touch the others
      card.classList.toggle('active');
    });
  });
});
